import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import SignIn from 'views/signin/SignIn';

import { useAuth } from 'auth';

const PrivateLayoutRoute = ({
  component: Component,
  layout: Layout,
  viewName,
  manager,
  hardwareManager,
  excludeOfficeManager,
}) => {
  const { isSignedIn, hasTenant, isManager, isHardwareManager, isOfficeManager } = useAuth();

  if (!isSignedIn) {
    return <SignIn />;
  }

  if (!hasTenant) {
    return <Navigate to="/welcome" replace />;
  }

  if (manager) {
    const allowed =
      (isManager || (hardwareManager && isHardwareManager)) &&
      !(excludeOfficeManager && isOfficeManager);

    if (!allowed) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  if (Layout) {
    return (
      <Layout viewName={viewName}>
        <Component />
      </Layout>
    );
  }

  return <Component />;
};

PrivateLayoutRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  layout: PropTypes.elementType,
  viewName: PropTypes.string,
  manager: PropTypes.bool,
  hardwareManager: PropTypes.bool,
  excludeOfficeManager: PropTypes.bool,
};

PrivateLayoutRoute.defaultProps = {
  layout: undefined,
  viewName: undefined,
  manager: false,
  hardwareManager: false,
  excludeOfficeManager: false,
};

export default PrivateLayoutRoute;
